import React, { Component } from 'react'
import style from './style.scss'

export default class Logo extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return <div className={style.logo} />
    }

}



// WEBPACK FOOTER //
// src/components/logo/index.js